import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";
import { SpinnerLegacy } from "../components";
import { useAppInitialization } from "../hooks/useAppInitialization";
import { UserSignupStep } from "../pages/auth/signup/steps/UserSignupStep";
import { AppRoutes } from "./AppRoutes";

export const AppRoutingBoundary = () => {
  const [onboardingContinueUrl, setOnboardingContinueUrl] = useLocalStorage<
    string | null
  >("onboardingContinueUrl", null);
  const initialization = useAppInitialization();

  const onboardingContinueUrlFullPath = `${window.location.origin}${onboardingContinueUrl}`;
  const isViewingContinueUrl =
    onboardingContinueUrlFullPath === window.location.href;

  useEffect(() => {
    if (isViewingContinueUrl) setOnboardingContinueUrl(null);
  }, [isViewingContinueUrl, setOnboardingContinueUrl]);

  if (
    initialization.state.status === "initialization-error" ||
    initialization.state.status === "retrying-initialization"
  )
    return <UserSignupStep />;

  if (initialization.state.status !== "ready") return <SpinnerLegacy />;

  return <AppRoutes initialization={initialization} />;
};
